export const groupByAsMap = <T, K = keyof T>(list: T[], keyGetter: (item: T) => K, keyIdentifier?: (key: K, item: T) => boolean) => {
  const map = new Map<K, T[]>();

  list.forEach((item: T) => {
    let key: K;
    if (typeof keyIdentifier === 'function') {
      const keys = [...map.keys()];
      const keyIndex = keys.findIndex((x) => keyIdentifier(x, item));

      if (keyIndex >= 0) {
        key = keys[keyIndex];
      } else {
        key = keyGetter(item);
      }
    } else {
      key = keyGetter(item);
    }

    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });

  return map;
};
